import { useCallback, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const BidsPanel = () => {
  const [bids, setBids] = useState([]);
  const [msg, setMsg] = useState({});
  const [state, setState] = useState("loading");
  const load = useCallback(() => {
    fetch(`${API}/api/admin/vendor-bids`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("load"))))
      .then((j) => { setBids((j.bids || []).filter((b) => !/^TEST/i.test(b.property_address || ""))); setState("ok"); })
      .catch(() => setState("error"));
  }, []);
  useEffect(load, [load]);
  const accept = async (b) => {
    const id = b.bid_id;
    const warn = b.flagged_for_ceo_review ? `\n\nThis bid is above the fair baseline (${b.flag_reason}).` : "";
    if (!window.confirm(`Accept ${b.vendor_name}'s bid of $${b.total_bid.toLocaleString()} and email the signed work order?${warn}`)) return;
    setMsg((m) => ({ ...m, [id]: "Signing…" }));
    const q = b.flagged_for_ceo_review ? "?confirm_flagged=true" : "";
    const r = await fetch(`${API}/api/admin/vendor-bids/${id}/accept${q}`, { method: "POST", credentials: "include" });
    const j = await r.json().catch(() => ({}));
    setMsg((m) => ({ ...m, [id]: r.ok ? "Accepted · signed work order emailed" : j.detail || "Could not accept" }));
    if (r.ok) setTimeout(load, 1200);
  };
  return (
    <div className="rr-bids" data-testid="roster-bids-panel">
      <div className="rr-bids__title">Bids awaiting your decision</div>
      {state === "loading" && <div className="rr-muted" data-testid="roster-bids-loading">Loading bids…</div>}
      {state === "error" && <div className="rr-muted" data-testid="roster-bids-error">Couldn't load bids. Refresh to try again.</div>}
      {state === "ok" && bids.length === 0 && <div className="rr-muted" data-testid="roster-bids-empty">No open bids</div>}
      {bids.map((b) => (
        <div key={b.bid_id} className="rr-bid" data-testid={`roster-bid-${b.bid_id}`}>
          <div><b>{b.vendor_name}</b> · {b.trade_label} · {b.property_address}</div>
          <div>${b.total_bid.toLocaleString()} · {b.eta_hours}h{b.flagged_for_ceo_review ? " · above baseline" : ""}</div>
          <button type="button" onClick={() => accept(b)} data-testid={`roster-bid-accept-${b.bid_id}`}>Accept & sign</button>
          {msg[b.bid_id] && <span data-testid={`roster-bid-msg-${b.bid_id}`}>{msg[b.bid_id]}</span>}
        </div>
      ))}
    </div>
  );
};
